"use client";

import { useState, useRef, useLayoutEffect, type ReactNode } from "react";
import { cn } from "@/lib/utils";

type ExpandableTextProps = {
  children: ReactNode;
  lines?: number;
  className?: string;
};

const ExpandableText = ({ children, lines = 4, className }: ExpandableTextProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    setIsClamped(el.scrollHeight > el.clientHeight + 1);
  }, [children]);

  return (
    <div className={className}>
      <div
        ref={contentRef}
        className={cn(!expanded && `line-clamp-${lines}`)}
        style={!expanded ? { WebkitLineClamp: lines, display: "-webkit-box", WebkitBoxOrient: "vertical", overflow: "hidden" } : undefined}
      >
        {children}
      </div>
      {isClamped && !expanded && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(true);
          }}
          className="text-copy-sm text-gray-75 hover:underline mt-1"
        >
          Mehr
        </button>
      )}
    </div>
  );
};

export { ExpandableText };
